import { useGetMessagingConfig } from './use-get-messaging-config.hook';

type MessagingConfig = {
  attributes: {
    description: string;
    name: string;
    value: any;
  };
};

export const useGetComposeMessageFooterConfig = () => {
  const { data } = useGetMessagingConfig();

  const getAttributeByName = (attrName: string) => {
    const attrData = data?.data?.find(
      (config: MessagingConfig) => config?.attributes?.name === attrName,
    );

    return attrData?.attributes?.value;
  };

  const allowedFileTypes = getAttributeByName('DOC_TYPES') ?? '';
  const maxFileSize = getAttributeByName('DOC_MAX_SIZE')
    ? Number(getAttributeByName('DOC_MAX_SIZE'))
    : undefined;
  const documentUploadEnabled =
    getAttributeByName('DOC_UPLOAD_ENABLED') === 'true';
  const maxMessageLength = getAttributeByName('MESSAGE_MAX_SIZE')
    ? Number(getAttributeByName('MESSAGE_MAX_SIZE'))
    : undefined;
  const maxNumberOfDocs = getAttributeByName('MAX_NUMBER_OF_DOCS')
    ? Number(getAttributeByName('MAX_NUMBER_OF_DOCS'))
    : undefined;
  return {
    allowedFileTypes,
    maxFileSize,
    documentUploadEnabled,
    maxMessageLength,
    maxNumberOfDocs,
  };
};
